// Color constants for the Home Matters application

export const COLORS = {
  // Primary colors - Home Matters brand
  $primaryBlue: '#1890FF',     // Professional blue for primary actions
  $primaryBlueDark: '#096DD9', // Darker blue for hover states
  $primaryBlueLight: '#40A9FF', // Lighter blue for highlights
  
  // Accent colors
  $accentGreen: '#52C41A',     // Success green
  $accentOrange: '#FA8C16',    // Warning orange
  $accentRed: '#F5222D',       // Error red
  
  // Neutral colors
  $white: '#FFFFFF',
  $lightGray: '#F5F5F5',
  $mediumGray: '#D9D9D9',
  $darkGray: '#595959',
  $black: '#262626',
  
  // Theme colors
  $colorPrimary: '#1890FF',
  $colorSecondary: '#52C41A',
};

// For backwards compatibility and convenience
export const colors = COLORS;
export default COLORS;
